export default function getTotalDiseasesAndPhenotypes(hpo) {
  const { diseases, phenotypes } = hpo || {};
  const checkedDis = (diseases || []).filter((x) => x.checked);
  const checkedPhens = (phenotypes || []).filter((x) => x.checked);
  const checkedDisPhens = (diseases || [])
    .map((x) => x.phenotypes)
    .filter((x) => Array.isArray(x))
    .reduce((a, i) => [...a, ...i], [])
    .filter((x) => x.checked);

  return checkedDis.length + checkedPhens.length + checkedDisPhens.length;
}
